import React from "react";
import { Role } from "../../../../services/roles.service";

interface Props {
  roles:     Role[];   // assignable roles - typically the clinic's clones, not system templates
  value:     string[]; // selected role_ids
  onChange:  (roleIds: string[]) => void;
  disabled?: boolean;
}

/** Checkbox-list role picker. Deliberately not a native <select multiple> -
 *  matches the existing checkbox idiom and works on mobile; also the natural
 *  place to add drag-to-reorder later without changing the data flow (it
 *  only owns value/onChange). */
export const RoleMultiSelect: React.FC<Props> = ({ roles, value, onChange, disabled }) => {
  const toggle = (roleId: string) => {
    if (disabled) return;
    onChange(value.includes(roleId) ? value.filter(id => id !== roleId) : [...value, roleId]);
  };

  return (
    <div className="border border-gray-200 rounded-lg divide-y divide-gray-100 max-h-64 overflow-y-auto">
      {roles.map(role => {
        const checked = value.includes(role.role_id);
        return (
          <label
            key={role.role_id}
            className={`flex items-start gap-2.5 px-3 py-2.5 min-h-[44px] ${disabled ? "" : "cursor-pointer hover:bg-gray-50"}`}
          >
            <input
              type="checkbox"
              className="w-4 h-4 mt-0.5 rounded accent-blue-500 cursor-pointer disabled:cursor-not-allowed flex-shrink-0"
              checked={checked}
              disabled={disabled}
              onChange={() => toggle(role.role_id)}
            />
            <div className="min-w-0">
              <span className="text-sm text-gray-900">{role.name}</span>
              {role.description && <p className="text-xs text-gray-400">{role.description}</p>}
            </div>
          </label>
        );
      })}
    </div>
  );
};
